export default function ({commit}) {
    commit('list/clean');
    commit('tab');
}